import React from 'react';
import Icon from '../Icon/Icon';
import emptyPageSvg from '../../../assets/empty-page.svg';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  message: string;
  icon?: string;
  iconSize?: number;
  showImage?: boolean;
  compact?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  icon,
  iconSize,
  showImage = true,
  compact = false,
}) => {
  const resolvedIconSize = iconSize ?? (compact ? 22 : 40);
  const imageWidth = compact ? 96 : 120;
  const imageHeight = compact ? 108 : 135;

  return (
    <div className={`${styles['empty-state']} ${compact ? styles.compact : ''}`.trim()}>
      {showImage && !icon && (
        <div className={styles.image}>
          <img src={emptyPageSvg} alt="" width={imageWidth} height={imageHeight} />
        </div>
      )}
      {icon && (
        <div className={styles.icon}>
          <Icon name={icon} size={resolvedIconSize} />
        </div>
      )}
      <p className={styles.message}>{message}</p>
    </div>
  );
};

export default EmptyState;
